<template>
  <div class="slfcntr text-noselect">
    <SolfigrStrategyComparison
      v-if="hasStrategyComparison"
      :catDraws="catDraws"
      :catEqBuckets="catEqBuckets"
      :catEqBucketsAdvanced="catEqBucketsAdvanced"
      :catHands="catHands"
      :grouping="grouping"
      :heroSolution="heroSolution"
      :isPreflop="isPreflop"
      :opponentSolution="opponentSolution"
      :readOnly="skeletonOnly"
      :showBetsIn="showBetsIn"
      :skeleton="skeletonOnly"
      :useHex="useHex"
      @cat:mouseenter="cat => handleCatMouseenter(cat)"
      @cat:mouseleave="() => handleCatMouseleave()"
      @cat:click="cat => handleCatClick(cat)"
    ></SolfigrStrategyComparison>
    <TrainerRangesComparison
      v-if="hasRangesComparison"
      :staticCustomRows="staticCustomRows()"
      :catDraws="catDraws"
      :catEqBuckets="catEqBuckets"
      :catEqBucketsAdvanced="catEqBucketsAdvanced"
      :catHands="catHands"
      :filterCategories="filterCategories"
      :filterCombos="filterCombos"
      :hasCategories="true"
      :hasGuides="true"
      :hasTitlePlayers="false"
      :isPreflop="isPreflop"
      :playerLeft="heroLeft ? hero : opponent"
      :playerRight="heroLeft ? opponent : hero"
      :playerLeftKey="heroLeft ? '0' : '1'"
      :playerRightKey="heroLeft ? '1' : '0'"
      :readOnly="skeletonOnly"
      :showFlopContent="true"
      :skeleton="skeletonOnly"
      :staticHiddenRows="['ev']"
      :staticRowsOrder="['ev_hero', 'ev_opponent', 'combos', 'eq', 'eqr']"
      class="slfcntr_ranges-comparison no-scroll-track"
      style="
        --clr-trrcmp-item-active: var(--tracactr-item-active);
        --clr-trrcmp-item-inactive: var(--tracactr-item-inactive);
      "
      @cat:mouseenter="cat => handleCatMouseenter(cat)"
      @cat:mouseleave="() => handleCatMouseleave()"
      @cat:click="cat => handleCatClick(cat)"
    >
    </TrainerRangesComparison>
  </div>
</template>

<script>
import { SNK, getPercentageOfMax } from '@/helpers/helpers'
import TrainerRangesComparison from '@/components/Trainer/TrainerRangesComparison'
import SolfigrStrategyComparison from '@/components/Dialogs/Solfigr/SolfigrStrategyComparison'

import float_mix from '@/mixins/float_mix'

export default {
  name: 'SolfigrNodeCompareCenter',
  components: {
    TrainerRangesComparison,
    SolfigrStrategyComparison,
  },
  mixins: [float_mix],
  props: {
    catDraws: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,
    catHands: Array,
    filterCategories: { default: () => [] },
    filterCombos: Object,
    grouping: String,
    hasFilterSuits: Boolean,
    hasRangesComparison: Boolean,
    hasRangesComparisonTitlePlayers: Boolean,
    hasStrategyComparison: Boolean,
    players1: Array,
    players2: Array,
    hero: Object,
    heroLeft: Boolean,
    heroSolution: Array,
    isPreflop: Boolean,
    namespace: { required: true, type: String },
    opponent1: Object,
    opponent2: Object,
    opponent: Object,
    opponentSolution: Array,
    showBetsIn: String,
    skeletonOnly: Boolean,
    useHex: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    getEv(player) {
      return player?.total_ev || 0
    },
    getPercentEV(hero, opponent, player) {
      const max = (hero?.total_ev || 0) + (opponent?.total_ev || 0)
      const res = getPercentageOfMax({ max, value: player?.total_ev || 0 })
      return res
    },
    handleCatMouseleave() {
      this.$store.dispatch(SNK('sol_detail_highlight', this.namespace), null)
    },
    handleCatMouseenter(category) {
      this.$store.dispatch(SNK('sol_detail_highlight', this.namespace), category)
    },
    staticCustomRows() {
      let rows = []
      // TODO: remove after 3way release
      if (this.$store.getters.user_has_flag('SOL_3WAY') && this.players1 && this.players2) {
        rows = this.players1.map((player, index) => ({
          id: `ev_${player.position}`,
          title: this.$t('common.ev_player', {
            player: player.position ? this.$t(`players.${player.position}`) : '',
          }),
          decimal: 2,
          name: 'total_ev',
          unit_note: '%',
          fn_note: val => val * 100,
          hasEvNote: true,
          guide: 'ra_compare_ev',
          playerLeftValue: player ? player.total_ev : 0,
          playerRightValue: this.players2[index] ? this.players2[index].total_ev : 0,
          hero_note: false,
          opponent_note: false,
        }))
      } else {
        rows = [
          {
            id: 'ev_hero',
            title: this.$t('common.ev_player', {
              player:
                this.hero && this.hero.position ? this.$t(`players.${this.hero.position}`) : '',
            }),
            decimal: 2,
            name: 'total_ev',
            unit_note: '%',
            fn_note: val => val * 100,
            hasEvNote: true,
            guide: 'ra_compare_ev',
            playerLeftValue: this.hero ? this.hero.total_ev : 0,
            playerRightValue: this.opponent ? this.opponent.total_ev : 0,
            hero_note: false,
            opponent_note: false,
          },
          {
            id: 'ev_opponent',
            title: this.$t('common.ev_player', {
              player:
                this.opponent1 && this.opponent1.position
                  ? this.$t(`players.${this.opponent1.position}`)
                  : '',
            }),
            decimal: 2,
            name: 'total_ev',
            unit_note: '%',
            fn_note: val => val * 100,
            hasEvNote: true,
            guide: 'ra_compare_ev',
            playerLeftValue: this.opponent1 ? this.opponent1.total_ev : 0,
            playerRightValue: this.opponent2 ? this.opponent2.total_ev : 0,
            hero_note: false,
            opponent_note: false,
          },
        ]
      }

      return rows
    },
    handleCatClick(item) {
      this.$store.dispatch(SNK('sol_filters_toggleCategory', this.namespace), {
        category: item.category,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.slfcntr {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.slfcntr_evchart {
  &_legend {
    &_item {
    }
  }

  &_players {
    &_player {
      &_left {
      }
      &_right {
      }
    }
  }
}
</style>
